/**
 * Fusion Mont category navigation.
 * Combo Basket / Combo Product = page links.
 * All / collections = Section Rendering API swap of homepage products section.
 * Fallback: full navigation if fetch fails.
 */
(function () {
  const ACTIVE_CLASS = 'fusion-categories__link--active';

  function init(nav) {
    if (nav.dataset.fusionReady === 'true') return;
    nav.dataset.fusionReady = 'true';

    const sectionId = nav.dataset.productsSectionId || 'fusion_home_products';
    const allUrl = nav.dataset.allUrl || '/collections/all';
    const links = nav.querySelectorAll('[data-fusion-category]');

    links.forEach((link) => {
      link.addEventListener('click', async (event) => {
        const type = link.dataset.fusionCategory;
        if (type === 'page' || type === 'collection' || type === 'all') return;

        event.preventDefault();

        const handle = link.dataset.collectionHandle || 'all';
        const targetUrl = link.getAttribute('href') || (handle === 'all' ? allUrl : link.href);

        setActive(nav, link);

        const ok = await swapProducts({
          sectionId,
          collectionUrl: targetUrl,
          handle,
        });

        if (!ok && !window.Shopify?.designMode) {
          window.location.href = targetUrl;
        }
      });
    });
  }

  function setActive(nav, activeLink) {
    nav.querySelectorAll('[data-fusion-category]').forEach((link) => {
      const isActive = link === activeLink;
      link.classList.toggle(ACTIVE_CLASS, isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  async function swapProducts({ sectionId, collectionUrl }) {
    const host =
      document.getElementById(`shopify-section-${sectionId}`) ||
      document.querySelector('[data-fusion-home-products]')?.closest('[id^="shopify-section-"]');
    if (!host) return false;

    const resolvedId = host.id.replace(/^shopify-section-/, '') || sectionId;
    const url = new URL(collectionUrl, window.location.origin);

    try {
      url.searchParams.set('sections', resolvedId);
      const response = await fetch(url.toString(), {
        headers: { Accept: 'application/json' },
      });

      if (response.ok) {
        const payload = await response.json();
        const html = payload[resolvedId];
        if (html) {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          const next =
            wrapper.querySelector(`#shopify-section-${resolvedId}`) || wrapper.firstElementChild;
          if (next) {
            host.replaceWith(next);
            return true;
          }
        }
      }

      url.searchParams.delete('sections');
      url.searchParams.set('section_id', resolvedId);
      const htmlResponse = await fetch(url.toString());
      if (!htmlResponse.ok) return false;
      const html = await htmlResponse.text();
      if (!html.trim()) return false;

      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      const next =
        wrapper.querySelector(`#shopify-section-${resolvedId}`) ||
        wrapper.querySelector('[data-fusion-home-products]') ||
        wrapper.firstElementChild;
      if (!next) return false;

      if (next.id && next.id.startsWith('shopify-section-')) {
        host.replaceWith(next);
      } else {
        host.innerHTML = next.outerHTML;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  function boot() {
    document.querySelectorAll('[data-fusion-category-nav]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
